import {Icon} from '@blueprintjs/core';

import {Tooltip, Icon as MuiIcon} from '@material-ui/core';
import {nav, site} from '@stores'
import {computed, lockr, observable, React, runInAction} from '@api'
import {PrimaryIconButton} from 'centric-ui-components';
import {action, autorun, toJS} from 'mobx'
import {observer} from 'mobx-react'
import DevTools, {configureDevtool, setGraphEnabled, setLogEnabled, setUpdatesEnabled} from 'mobx-react-devtools'
import * as css from './CustomMobxDevTools.css'
import { Tooltip2 } from '@api';

@observer
export class CustomMobxDevTools extends React.Component<{}> {
  render() {
    const {mobxDevToolConfig: config} = mobxDevTool
    const {log, updates, graph}               = config
    return <div className={css.root}>
      <DevTools noPanel/>
      <div className={css.panel}>
        <Tooltip2 content='Log to Console' placement='bottom'>
          <PrimaryIconButton active={log.enabled} onClick={() => log.enabled = !log.enabled} icon={<Icon icon='console'/>}/>
        </Tooltip2>

        <Tooltip2 content='Component Timings' placement='bottom'>
          <PrimaryIconButton active={updates} onClick={() => config.updates = !updates} icon={<Icon icon='time'/>}/>
        </Tooltip2>
        <Tooltip2 content='Call Graph' placement='bottom'>
          <PrimaryIconButton active={graph} onClick={() => config.graph = !graph} icon={<Icon icon='diagram-tree'/>}/>
        </Tooltip2>
        {/*<GraphControl />*/}
        {/*<LogControl />*/}
        {/*<UpdatesControl />*/}
        <Tooltip2 content='Log Actions' placement='bottom'>
          <PrimaryIconButton active={log.actions} onClick={() => log.actions = !log.actions} icon={<Icon icon='take-action'/>}/>
        </Tooltip2>
        <Tooltip2 content='Log Reactions' placement='bottom'>
          <PrimaryIconButton active={log.reaction} onClick={() => log.reaction = !log.reaction} icon={<Icon icon='send-to'/>}/>
        </Tooltip2>
        <Tooltip2 content='Log Direct Property Sets' placement='bottom'>
          <PrimaryIconButton active={log.updates} onClick={() => log.updates = !log.updates} icon={<Icon icon='updated'/>}/>
        </Tooltip2>
        <Tooltip2 content='Log Recomputes' placement='bottom'>
          <PrimaryIconButton active={log.computed} onClick={() => log.computed = !log.computed} icon={<Icon icon='calculator'/>}/>
        </Tooltip2>
        <Tooltip2 content='Log Component Renders' placement='bottom'>
          <PrimaryIconButton active={log.components} onClick={() => log.components = !log.components} icon={<Icon icon='refresh'/>}/>
        </Tooltip2>
        <Tooltip2 content='Log Scheduled Reactions' placement='bottom'>
          <PrimaryIconButton active={log.scheduledReactions} onClick={() => log.scheduledReactions = !log.scheduledReactions} icon={<Icon icon='feed-subscribed'/>}/>
        </Tooltip2>
        <Tooltip2 content='Log All' placement='bottom'>
          <PrimaryIconButton onClick={this.logAll} icon={<Icon icon='tick'/>}/>
        </Tooltip2>
        <Tooltip2 content='Log None' placement='bottom'>
          <PrimaryIconButton onClick={this.logNone} icon={<Icon icon='cross' />}/>
        </Tooltip2>
      </div>
    </div>
  }

  @action logAll = () => {
    const {mobxDevToolConfig: {log}} = mobxDevTool
    if (!log.enabled) {
      Object.assign(log, {updates: true, actions: true, components: false, computed: true, enabled: true, reaction: true, scheduledReactions: false})
    } else {
      Object.assign(log, {updates: false, actions: false, components: false, computed: false, enabled: false, reaction: false, scheduledReactions: false,})
    }
  }

  @action logNone = () => {
    const {mobxDevToolConfig: {log}} = mobxDevTool
    Object.assign(log, {updates: false, actions: false, components: false, computed: false, enabled: false, reaction: false, scheduledReactions: false,})
  }

 mobxConfig = autorun(() => {
   const {showDebugPanel, mobxDevToolConfig, mobxDevToolConfig: {graph, updates, log}} = mobxDevTool,
     {initialized} = site

   const {updates: ignored} = log

   if (!initialized) return

   setGraphEnabled(showDebugPanel && graph)
   setLogEnabled(showDebugPanel && log.enabled)
   setUpdatesEnabled(showDebugPanel && updates)

   if (!log.enabled) {
     Object.assign(log, {
       components: false, scheduledReactions: false,
       actions: false, computed: false,
       updates: false, reaction: false,
     })
   }

   lockr.set('mobxDevToolConfig', toJS(mobxDevToolConfig))
 }, {name: `Update mobx dev tools config`})
}

export class MobxDevToolsStore {
  constructor() {
    setTimeout(() => {
      DEBUG && this.manageMobxDevTool()
    }, 50)
  }
  
  @observable mobxDevToolConfig = {
    graph: false, updates: true, log: {
      enabled: true, components: false, scheduledReactions: false,
      actions: true, computed: true,
      updates: true, reaction: true,
    }
  }

  @computed get showDebugPanel() {
    return nav.queryParams.mobx !== undefined
  }

  @action manageMobxDevTool = () => {
    this.mobxDevToolConfig = lockr.get('mobxDevToolConfig') || this.mobxDevToolConfig

    configureDevtool({
      logFilter: ({type, name, object, ...info}) => {
        const {mobxDevToolConfig: {log: {components, enabled, scheduledReactions, actions, computed, reaction, updates}}} = this

        // console.log({type, name, object, info})

        // These aren't useful - they're @observables on a class being initialized
        if (type === 'add') {
          return false
        }
        else if (!enabled || (!scheduledReactions && type == 'scheduled-reaction')
            || (!components && type == 'reaction' && (name.endsWith('.render()') || name.startsWith('observer')))
            || (!actions && type == 'action')
            || (!computed && type == 'compute')
            || (!reaction && type == 'reaction')
            || (!updates && (type == 'update'))
        ) {
          return false
        }

        return true
      }
    })
  }
}

export const mobxDevTool = new MobxDevToolsStore()


// WEBPACK FOOTER //
// ./src/stores/dev/CustomMobxDevTools.tsx